module.exports = __webpack_public_path__ + "images/linear-regression2-23.webp";